module.exports = __webpack_public_path__ + "img/profiling.dc9cfe82.svg";